import * as h2Api from '../../h2Api'
import { appendSearchResults, initSearchResults } from '../search'

export const SP_RESULTS = 'SP_RESULTS'
export const ADD_SP_RESULTS = 'ADD_SP_RESULTS'

export const SD_RESULTS = 'SD_RESULTS'
export const ADD_SD_RESULTS = 'ADD_SD_RESULTS'

export const loadSpResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/skills/results`, { filters })({ type: SP_RESULTS })
  ).then(v => {
    console.log(v)
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentSpResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/assessment/skills/results`, updatedJson)({ type: ADD_SP_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}

export const loadDecoderResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/skills/decoder/results`, { filters })({ type: SD_RESULTS })
  ).then(v => {
    console.log(v)
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentDecoderResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(
      `/assessment/skills/decoder/results`,
      updatedJson
    )({ type: ADD_SD_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
